function page_scroll(){
  $('a').on("click", function() {
    if($(this).attr('href')){
    var url = $(this).attr('href') //get url
    if (url.indexOf('#') >= 0) {
      var arr = url.split('#');
    }
    var hash = arr[1];
    console.log(hash);
    if(hash != null) {
      var speed = 640;
      var header_height = $("#header").innerHeight();
      var position = $('#' + hash).offset().top - header_height;
      $('body,html').animate({scrollTop:position}, speed, 'easeOutExpo');
      return false;
    }
    }
  });

  var url = location.hash;
  if(url) {
      $('body,html').stop().scrollTop(0);
      var header_height = $("#header").innerHeight();
      setTimeout(function(){
          var target = $(url);
          var position = target.offset().top - headerHeight;
          $('body,html').stop().animate({scrollTop:position}, speed, 'easeOutExpo');
      }, 100);
  }
}

$('#myselector').on('click', 'a', function(){
    var hash = $(this).attr('href').replace('#', '') //get url
})

function header_height(){
  var headerH = $('#header').innerHeight();
  $('#main-content,.shopify-challenge__container').css('padding-top',headerH + 5);
}

function nav_child(){
  $('.lv1-item,.lv2-item,.lv3-item').each(function() {
    if(!$(this).find('ul').length){
      $(this).find('.has-lowerlv-menu-icon').hide(); 
    }
  });
}

function nav_curret(){
  var url = $(location).attr('pathname');
  $('.sp-nav__lists a').each(function() {
    if($(this).attr('href') == url){
      $(this).addClass('active');
    }
  });
}

function append_info(){
  var w = $(window).width();
  var s = 767;

    if (w <= s) {
      $('.product-form').appendTo('.menu-info');
    } else {
      $('.product-form').appendTo('.side-bar-info');
    }
}

function sidebar_ttl(){
  var url = $(location).attr('pathname');
  if (!$('.side-bar ').hasClass("account-side-bar") ) {
      $('.side-bar__list .list-item:first-child > a').addClass('side-bar__ttl'); 
  }
}

function store_list_num(){
  $('.accordion-container').each(function() {
    var num = $(this).find('.folding-list').length;
    $(this).find('.list-num').text(num + ' stores');
  });
}

function header_bnr(){
  $('.header__bnr__close').click(function() {
      $('.header__bnr').fadeOut();
  })
}

function header_bnr(){
  cookie = $.cookie('bnr');
  if(cookie){
      $('.header__bnr').hide();
  } else {
      $('.header__bnr__close').click(function() {
         $('.header__bnr').fadeOut();
         $.cookie('bnr','1',{ expires: 7 , path: '/' });
      });
  }
}

$(window).on('resize', function(){
    append_info();
});

$(window).on('load', function(){
    append_info();
});

function checkout(){
  var original = $('.bcpo-cart-original-total').text();
  var original = original.replace("¥", "");
  var original = original.replace(",", "");
  var last = $('.saw-cart-total').text();
  var last = last.replace("¥", "");
  var last = last.replace(",", "");
  if(original || last) {
    if(last) {
      if((Number(last)) < 33000) {
        $('#checkout').prop("disabled", true);
        alert('合計金額は33,000円以上である必要がございます');
      } else {
        $('#checkout').prop("disabled", false);
      }
    } else {
      if(Number(original) < 33000) {
        $('#checkout').prop("disabled", true);
        alert('合計金額は33,000円以上である必要がございます');
      } else {
        $('#checkout').prop("disabled", false);
      }
    }
  }
}

$('.address-edit-toggle').click(function() {
    $('.address-billing__inner').attr('aria-expanded','false');
})

/*setTimeout(function() {
  var original = document.querySelector('.bcpo-cart-original-total').textContent;
  console.log(original);
  var original = original.replace('¥', '');
  var original = original.replace(',', '');
  var last = document.querySelector('.saw-cart-total').textContent;
  var last = last.replace('¥', '');
  var last = last.replace(',', '');
  if(original || last) {
    if(last) {
      if((Number(last)) < 33000) {
        console.log(last);
        document.querySelector('#checkout').disabled = true;
        alert('合計金額は33,000円以上である必要がございます');
      } else {
      }
    } else {
      if(Number(original) < 33000) {
        console.log(original);
        document.querySelector('#checkout').disabled = true;
        alert('合計金額は33,000円以上である必要がございます');
      } else {
      }
    }
  }
}, 4000);*/

/*$(function(){
    var DoSum = function(self){
       var GROUP = self.data('group');
       var SUM = 0;
    
       $("[data-group='"+ GROUP +"']").each(function(index){
            SUM = SUM + Number($(this).attr('data-price'));
       });
    
       $("#sum" + GROUP).text(SUM);
    };
    
    $('[data-group]').change(function(){
        DoSum($(this));
    });
    DoSum($(this));
});*/

$(window).on('load', function() {
    $(".plists-item__link-wrapper").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('li').hide();
         }
    });
    $(".plists-item__link-box").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('li.plists__item').hide();
         }
    });
    $(".plists").each(function(index){
      var count = $(this).find(".plists__item").length;
      var none = 0;
      $(this).find(".plists__item").each(function(index){
         if ($(this).css('display') == 'none') {
            none++;
         }
      });
      if (count == none) {
        $(this).parents('li.content-item').hide();
      }
    });
    $(".item-ttl ").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('li').hide();
         }
    });
    $(".fragrance-list__item a").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('li').hide();
         }
    });
    $(".lv3-item > a").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('.lv3-item').hide();
         }
    });
    $(".lv4-item > a").each(function(index){
         if ($(this).css('display') == 'none') {
             // 表示されている場合の処理
             $(this).parents('.lv4-item').hide();
         }
    });
  　//checkout();
    //header_height();
    //nav_child();
    //nav_curret();
    //sidebar_ttl();
    //append_info();
    //store_list_num();
    ////page_scroll();
    //header_bnr();
});

/*
$(function(){
  cartCount = $('#CartCount').text();
  if (!$.cookie('cart_num')) {
    $.cookie('cart_num', cartCount);
  } else {
    if($.cookie('cart_num') != cartCount) {
      $('.mini-cart').addClass('open');
      $.cookie('cart_num', cartCount);
    }
  }
});*/